<mat-slide-toggle [(ngModel)]="valore"
                  [color]="color"
                  [disabled]="block ? block : false"
                  (change)="valueChange($event.checked)">
  {{testo}}
</mat-slide-toggle>
